export enum NotificationType {
  BALANCE_CHANGED = 'altgame.reddog.wallet.v2.balance.changed',
}
